import React from "react";

const DataDeletion: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 bg-neutral-100 overflow-y-auto">
      <div className="min-h-screen flex justify-center px-4 py-16">
        <div className="w-full max-w-5xl bg-white rounded-lg border border-neutral-200 px-8 sm:px-12 py-12">

          <h1 className="text-4xl font-semibold text-neutral-900 text-center mb-12">
            Data Deletion Instructions
          </h1>

          <div className="prose prose-neutral max-w-none text-neutral-800">

            <p className="text-base leading-relaxed">
              At <strong>Busiconn</strong> (operated by Mansud Enterprises Pvt.
              Ltd.), we value your privacy and provide transparent options to
              manage or delete your data in compliance with applicable privacy
              regulations.
            </p>

            {/* How to Delete */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                How to Delete Your Data
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ol className="list-decimal pl-6 space-y-4">
                  <li>
                    <strong>Delete in the mobile app:</strong> Open Profile →
                    Edit Profile → Delete Account, review the warning, and confirm.
                    This initiates deletion of the account and associated personal data.
                  </li>

                  <li>
                    <strong>Request full account data deletion:</strong> To
                    delete your account and associated personal data outside the app,
                    email{" "}
                    <a className="text-primary-600 underline" href="mailto:contact@busiconn.com?subject=Busiconn%20Account%20Deletion%20Request">
                      contact@busiconn.com
                    </a>{" "}with the subject line{" "}
                    <em>
                      “Data Deletion Request - [Your Account Email or Username]”
                    </em>.
                  </li>

                  <li>
                    <strong>Processing timeline:</strong> Requests are verified
                    and processed within <strong>7 business days</strong>.
                    Backup systems may retain data temporarily for technical or
                    compliance purposes and will be purged automatically.
                  </li>

                  <li>
                    <strong>Retention exceptions:</strong> Certain data,
                    including financial transactions, payouts, disputes, or tax
                    records, may be retained for up to{" "}
                    <strong>7 years</strong> as required by Indian law.
                  </li>

                  <li>
                    <strong>Verification step:</strong> We may request
                    confirmation from your registered email address before
                    completing deletion.
                  </li>
                </ol>
              </div>
            </section>

            {/* Important Notes */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Important Notes
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ul className="list-disc pl-6 space-y-2">
                  <li>Data deletion is permanent and cannot be reversed.</li>
                  <li>Deleted accounts cannot be accessed again.</li>
                  <li>
                    Public posts are deactivated and personal account data is deleted or de-identified,
                    subject to legally required retention.
                  </li>
                </ul>
              </div>
            </section>

            {/* Contact */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Contact Us
              </h2>

              <div className="border border-neutral-200 rounded-md p-6 text-sm">
                <p>
                  Email: <strong>contact@busiconn.com</strong>
                </p>
              </div>
            </section>

            <p className="text-xs text-neutral-500 text-center mt-16">
              Last Updated: 19 September 2026
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDeletion;
